var YouLi = YouLi ? YouLi : {};
YouLi.TravellerLogin = YouLi.TravellerLogin ? YouLi.TravellerLogin : {};

(function (YouLi) {
    (function (TravellerLogin) {

        YouLi.TravellerLogin.ReturnUrl = "";

        DoLogin = function (email, password, returnUrl, templateCode, partnerCode, selectedPlan, skipTripFind, token) {

            YouLi.Common.UI.ShowButtonLoading($("#PasswordFormContinue"));


            var data = {
                "email": encodeURIComponent(email),
                "password": password,
                "returnUrl": returnUrl,
                "templateCode": templateCode,
                "partnerCode": partnerCode,
                "selectedPlan": selectedPlan,
                "skipTripFind": skipTripFind
            };

            YouLi.Common.Post({
                url: '/account/login',
                params: data,
                contentType: 'application/json',
                suppressLoading: true,
                fetchOptions: {
                    headers: {
                        '__RequestVerificationToken': token
                    }
                },
                errorCallback: function (response) {
                    if (response.status == 500 || response.statusText == 'error') {
                        YouLi.Common.UI.HideButtonLoading($("#PasswordFormContinue"));
                        alert("We encountered an error");
                    }
                }
            }).then(function (response) {
                if (response.errorMessage) {
                    $(".login-error").html(response.errorMessage).fadeIn();
                    YouLi.Common.UI.HideButtonLoading($("#PasswordFormContinue"));
                }
                else if (response.redirect) {
                    window.location.href = response.redirect;
                }
                else {
                    $(".login-error").html("Some error occurred").fadeIn();
                    YouLi.Common.UI.HideButtonLoading($("#PasswordFormContinue"));
                }
            });
        };

        CheckEmail = function (emailElement, returnUrl, templateCode, partnerCode, selectedPlan, skipTripFind, token, searchCurrentTrips) {

            if (!emailElement.valid()) {
                return;
            }

            YouLi.Common.UI.ShowButtonLoading($("#EmailFormContinue"));

            var data = {
                "email": encodeURIComponent(emailElement.val()),
                "returnUrl": returnUrl,
                "templateCode": templateCode,
                "partnerCode": partnerCode,
                "selectedPlan": selectedPlan,
                "skipTripFind": skipTripFind,
                "plannerAlias": $("#CustomBranding_BrandAlias").val(),
                "searchCurrentTrips": searchCurrentTrips
            };

            YouLi.Common.Post({
                url: '/account/checkemail',
                params: data,
                contentType: 'application/json',
                suppressLoading: true,
                fetchOptions: {
                    headers: {
                        '__RequestVerificationToken': token
                    }
                },
                errorCallback: function (response) {
                    if (response.status == 500 || response.statusText == 'error') {
                        YouLi.Common.UI.HideButtonLoading($("#EmailFormContinue"));
                        alert("We encountered an error");
                    }
                }
            }).then(function (response) {
                if (response.redirect) {
                    window.location.href = response.redirect;
                }
                else {
                    YouLi.Common.UI.HideButtonLoading($("#EmailFormContinue"));

                    if (response.message) {
                        $(".login-error").html(response.message).fadeIn();
                    }
                    else {
                        FormTransition("planner");
                    }
                }
            });
        };

        FormTransition = function (stepName) {
            if (stepName == "email") {
                $(".page-dialogue__header h2").text("Let's find your way");

                $(".password-form").addClass("notshown");
                $(".email-form").fadeIn();

                $("#Email").prop("disabled", false);
                $("#InputEditIcon").hide();
                $("#EmailField").off("click");

                $(".page-dialogue__header-subheading").html("We will get you to the right place once we know who you are.");
                $("#IntroText").html("Enter your email so we can help you find or create your trips.");
            }
            else if (stepName == "planner") {
                $(".page-dialogue__header h2").text("Welcome Back");

                $(".email-form").fadeOut(function () {
                    $(".password-form").removeClass("notshown");
                    $("#Password").focus();
                });

                $("#Email").prop("disabled", true);
                $("#InputEditIcon").show();
                $("#EmailField").on("click", function () {
                    FormTransition("email");
                });

                $(".page-dialogue__header-subheading").html("We found an account with that email address.");
                $("#IntroText").removeClass("text-center").html("Please enter your password to login");
                $(".forgot-password-link").attr("href", "/Account/ForgotPassword/?email=" + encodeURIComponent($("#Email").val()));
            }
        };

        $(function () {

            $("#Email").focus();

            $("#Email").keyup(function (event) {
                if (event.keyCode === 13) {
                    $("#EmailFormContinue").click();
                    event.preventDefault();
                }
            });

            $("#Password").keyup(function (event) {
                if (event.keyCode === 13) {
                    $("#PasswordFormContinue").click();
                }
            });

            $("#LoginForm").on("click", "#EmailFormContinue", function () {
                var returnUrl = $("#ReturnUrl").val();
                var templateCode = $("#TemplateCode").val();
                var partnerCode = $("#PartnerCode").val();
                var selectedPlan = $("#SelectedPlan").val();
                var skipTripFind = $("#SkipTripFind").val();
                var searchCurrentTrips = $('#SearchCurrentTrips').val();
                var token = $('input[name="__RequestVerificationToken"]', '#LoginForm').val();

                $(".login-error").fadeOut();

                CheckEmail($("#Email"), returnUrl, templateCode, partnerCode, selectedPlan, skipTripFind, token, searchCurrentTrips);

            });

            $("#LoginForm").on("click", "#PasswordFormContinue", function () {
                var email = $("#Email").val();
                var password = $("#Password").val();
                var returnUrl = $("#ReturnUrl").val();
                var templateCode = $("#TemplateCode").val();
                var partnerCode = $("#PartnerCode").val();
                var selectedPlan = $("#SelectedPlan").val();
                var skipTripFind = $("#SkipTripFind").val();
                var token = $('input[name="__RequestVerificationToken"]', '#LoginForm').val();

                $(".login-error").fadeOut();

                var searchCurrentTrips = $('#SearchCurrentTrips').val();

                DoLogin(email, password, returnUrl, templateCode, partnerCode, selectedPlan, skipTripFind, token, searchCurrentTrips);
            });
        });

    }(YouLi.TravellerLogin ? YouLi.TravellerLogin : {}));
}(YouLi ? YouLi : {}));